module.exports = __webpack_public_path__ + "static/media/Item_Weapon_BerylM762_C.349b0f0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_BerylM762_C.png
// module id = 214
// module chunks = 0